import React from 'react';
import { config } from '../config/config';

const FloatingButtons = () => {
  const handleCall = () => {
    window.location.href = `tel:${config.business.contact}`;
  };

  const handleWhatsApp = () => {
    const whatsappNumber = config.business.whatsapp || config.business.contact;
    window.open(`https://wa.me/91${whatsappNumber.replace(/\D/g, '')}`, '_blank');
  };

  return (
    <div className="fab">
      <button onClick={handleCall} title="Call Now">
        📞
      </button>
      <button className="green" onClick={handleWhatsApp} title="WhatsApp">
        💬
      </button>
    </div>
  );
};

export default FloatingButtons;
